































import { Component, Prop, Vue } from 'vue-property-decorator'

// Component
import ImportCSVModalLayout from '@/components/common/modals/ImportCSVModalLayout.vue'

@Component({
  components: { ImportCSVModalLayout },
})
export default class CardImportCSVModal extends Vue {
  @Prop()
  isOpen!: boolean

  @Prop()
  csvFields!: string[]

  sanIdsErrors: string[] = []
}
